class HeaderPrimary {
  body;
  trigger;
  target;
  banner;
  targetBtnHeader;
  main;
  header;
  pixPlus = 0;
  lastScrollTop = 0;


  constructor() {
    this.body = document.querySelector("body");
    this.main = document.querySelector("main");
    this.header = document.querySelector("header");
    
    this.trigger = document.querySelectorAll('[data-trigger="header-primary"]');
    this.target = document.querySelector('[data-target="header-primary"]');
    this.targetBtnHeader = document.querySelector('[data-trigger="header-btn"]');
    this.banner = document.querySelector(
      '[data-trigger="header-primary-banner"]'
      );      
      if (this.target) {
        this._init();
      }
      
  }

  _init() {
    for (let index = 0; index < this.trigger.length; index++) {
      const element = this.trigger[index];
      element.addEventListener("click", (event) => {
        this._toggleNav(event);        
      });
    }

    // close menu if you click on body
    // this.body?.addEventListener("click", (event) => {
    //   if (this.body?.getAttribute("data-state") == "locked-for-header-primary")
    //     this.closeMenu();
    // });
    this.targetBtnHeader?.addEventListener("click", (event) => {
      if (this.body?.getAttribute("data-state") == "locked-for-header-primary")
      this.closeMenu();
    });
    // No close menu if you click on it
    this.target?.addEventListener("click", (event) => {
      event.stopPropagation();
    });
    this.banner?.addEventListener("click", (event) => {
      event.stopPropagation();
    });

    this.body.addEventListener("scroll", () => {
      this.addColorScoll();
    },false);

    window.addEventListener(
      "resize",
      (event) => {
        if (
          window.innerWidth >= 1025 &&
          this.body?.getAttribute("data-state") == "locked-for-header-primary"
        ) {
          this.closeMenu();
        }
      },
      true
    );
  }

  _toggleNav(event: any) {
    this._toggleState(this.body, "locked-for-header-primary", "unlocked");
    this._toggleState(this.target, "open", "closed");
    this._toggleState(event.currentTarget, "open", "closed");
    this._toggleState(this.banner, "open", "closed");
  }

  _toggleState(elem: Element | null, one: string, two: string) {
    if (elem) {
      const newState = elem.getAttribute("data-state") === one ? two : one;
      elem.setAttribute("data-state", newState);
    }
  }

  closeMenu() {
    this._toggleState(this.body, "locked-for-header-primary", "unlocked");
    this._toggleState(this.target, "open", "closed");
    this._toggleState(this.banner, "open", "closed");
    this._toggleState(this.trigger[0], "open", "closed");
  }

  addColorScoll() {
    const intPosition = this.body.scrollTop;
    let st = intPosition;
    if (st > this.pixPlus) {
      //  console.log('bas');
       this.pixPlus += 1;
       this.header?.classList.remove("transparent");
       
    } else if (st < this.pixPlus) {
      //  console.log('haut');
       this.pixPlus -= 1;

       if(st === 0) {
        // console.log(" à 0");
        this.header?.classList.add("transparent");
      } 

    }
    // else was horizontal scroll
    this.pixPlus = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }

}

export let headerPrimary = new HeaderPrimary();
